import { Box, Typography } from "@mui/material";
import React from "react";

const Advertisement: React.FC = () => {
  return (
    <Box textAlign="center">
      <Typography variant="h4" gutterBottom>
        Waiting for an ad
      </Typography>
    </Box>
  );
};

export default Advertisement;
